import { SYSTEM_FONT_DEFAULT, getSystemFontOption, getSystemFontOverride } from "./systemFont";

export const HEADER_CONFIG_SETTING_KEY = "headerConfig";

export const HEADER_MENU_DEFAULTS = [
  { key: "management", label: "Gestão", icon: "LayoutDashboard", visible: true, order: 1 },
  { key: "attendance", label: "Atendimento", icon: "MessageSquare", visible: true, order: 2 },
  { key: "modules", label: "Módulos", icon: "FolderOpen", visible: true, order: 3 },
  { key: "campaigns", label: "Campanhas", icon: "Megaphone", visible: true, order: 4 },
  { key: "administration", label: "Administração", icon: "Cog", visible: true, order: 5 },
];

export const HEADER_RIGHT_ACTION_DEFAULTS = [
  { key: "theme", label: "Tema", icon: "Moon", visible: true },
  { key: "support", label: "Suporte", icon: "LifeBuoy", visible: true },
  { key: "help", label: "Ajuda IA", icon: "CircleHelp", visible: true },
  { key: "clipboard", label: "Prancheta", icon: "ClipboardList", visible: true },
  { key: "volume", label: "Volume", icon: "Volume2", visible: true },
  { key: "notifications", label: "Notificações", icon: "Bell", visible: true },
  { key: "announcements", label: "Avisos", icon: "AlertTriangle", visible: true },
  { key: "profile", label: "Perfil", icon: "UserCircle", visible: true },
  { key: "softphone", label: "Telefone flutuante", icon: "Phone", visible: true },
];

const SUBMENU_ICON_MAP = {
  // Gestão
  "/": "LayoutDashboard",
  "/reports": "FileText",
  "/analytics-template-whats": "BarChart3",
  "/meta-ads/campaigns": "Megaphone",
  "/meta-ads/analytics": "LineChart",
  "/meta-ads/reports": "FileSpreadsheet",
  "/meta-ads/roi": "DollarSign",
  "/moments": "Zap",

  // Atendimento
  "/tickets": "MessageSquare",
  "/emails": "Mail",
  "/quick-messages": "Zap",
  "/support-tickets": "LifeBuoy",
  "/portal-interno": "Globe",
  "/kanban": "Columns",
  "/chats": "MessagesSquare",
  "/contacts": "Users",
  "/my-wallet": "Briefcase",
  "/tags": "Tag",
  "/todolist": "ClipboardList",
  "/schedules": "Calendar",
  "/helps": "HelpCircle",

  // Módulos
  "/document-signature": "FileCheck",
  "/consulta-processo": "Gavel",
  "/advoc360": "Briefcase",
  "/social-triggers": "Zap",
  "/flow-process": "Workflow",
  "/flow-process/templates": "Layers",
  "/flow-process/categories": "Folder",
  "/flow-process/reports": "FileText",
  "/social-posts": "Share2",
  "/whatsapp-templates": "FaWhatsapp",
  "/meeting-rooms": "Video",
  "/agendacare": "Stethoscope",
  "/odontocare": "GiTooth",
  "/barber": "Scissors",
  "/educare": "GraduationCap",
  "/rotsa_360": "Map",
  "/petcare": "PawPrint",
  "/services": "Wrench",
  "/pdv": "ShoppingCart",
  "/comida-na-porta": "Utensils",
  "/motoqueiro": "Truck",
  "/woocommerce": "ShoppingBag",
  "/callcenter": "PhoneCall",
  "/callcenter-central": "Phone",
  "/erpfone": "Phone",
  "/voip": "PhoneCall",
  "/asaas-financial": "DollarSign",
  "/bancario-cartoes": "CreditCard",

  // Campanhas
  "/campaigns": "Megaphone",
  "/voice-campaigns": "Volume2",
  "/group-campaigns": "Users",
  "/email-campaigns": "Mail",
  "/contact-lists": "ListOrdered",

  // Administração
  "/users": "User",
  "/queues": "List",
  "/equipes": "UsersRound",
  "/group-management": "Building2",
  "/prompts": "Code",
  "/ai-agents": "Sparkles",
  "/ai-help-requests": "HelpCircle",
  "/ai-secretaria": "Sparkles",
  "/queue-integration": "Cable",
  "/messages-api": "Code",
  "/knowledge-base": "Info",
  "/evolution-interactives": "List",
  "/financeiro": "DollarSign",
  "/wallet-management": "Briefcase",
  "/settings": "Cog",
  "/announcements": "AlertTriangle",
  "/companies": "Building2",
  "/connections": "Wifi",
  "/allConnections": "Wifi",
};

const HEADER_SUBMENU_GROUPS = [
  ["management", [
    ["/", "Dashboard"], ["/reports", "Relatórios"], ["/analytics-template-whats", "Analytics Template Whats"],
    ["/meta-ads/campaigns", "Campanhas Meta"], ["/meta-ads/analytics", "Analytics Meta"],
    ["/meta-ads/reports", "Relatórios Meta"], ["/meta-ads/roi", "ROI Meta"], ["/moments", "Tempo Real"],
  ]],
  ["attendance", [
    ["/tickets", "Tickets"], ["/emails", "E-mail"], ["/quick-messages", "Mensagens rápidas"],
    ["/support-tickets", "Suporte"], ["/portal-interno", "Portal Interno"], ["/kanban", "Kanban"],
    ["/chats", "Chat interno"],
    ["/contacts", "Contatos"], ["/my-wallet", "Minha Carteira"], ["/tags", "Tags"],
    ["/todolist", "Tarefas"], ["/schedules", "Agendamentos"], ["/helps", "Ajuda"],
  ]],
  ["modules", [
    ["/document-signature", "Assinar com Certificado"], ["/consulta-processo", "Consulta Processo"],
    ["/advoc360", "Advoc-360"], ["/social-triggers", "Gatilhos"], ["/flow-process", "Processos"],
    ["/flow-process/templates", "Templates"], ["/flow-process/categories", "Categorias"],
    ["/flow-process/reports", "Relatórios"], ["/social-posts", "Rede Social"],
    ["/whatsapp-templates", "Whatsapp Templates"], ["/meeting-rooms", "Sala de reunião"],
    ["/agendacare", "AgendaCare"], ["/odontocare", "OdontoCare"], ["/barber", "Barbearia"],
    ["/educare", "EduCare"], ["/rotsa_360", "RotaVendas 360"], ["/petcare", "PetCare 360"], ["/services", "Serviços"], ["/pdv", "Caixa PDV"], ["/comida-na-porta", "Comida na Porta"],
    ["/motoqueiro", "Motoqueiro"], ["/woocommerce", "WooCommerce"], ["/callcenter", "Callcenter"],
    ["/callcenter-central", "Central Callcenter"], ["/erpfone", "ERP-PHONE"], ["/voip", "Telefone"],
    ["/asaas-financial", "Painel Asaas"], ["/bancario-cartoes", "Bancário/Cartões"],
  ]],
  ["campaigns", [
    ["/campaigns", "Campanhas"], ["/voice-campaigns", "Campanha por Voz"],
    ["/group-campaigns", "Campanha de Grupo"], ["/email-campaigns", "Campanha de E-mail"],
    ["/contact-lists", "Lista de Contatos"],
  ]],
  ["administration", [
    ["/users", "Usuários"], ["/queues", "Filas"], ["/equipes", "Equipes"],
    ["/group-management", "Gerenciar Grupos"], ["/prompts", "Prompts"],
    ["/ai-agents", "Agentes IA"], ["/ai-help-requests", "Solicitações da IA"],
    ["/ai-secretaria", "Ai Secretaria"], ["/queue-integration", "Integrações"],
    ["/messages-api", "API de Mensagens"], ["/knowledge-base", "Base de Conhecimento"],
    ["/evolution-interactives", "Gerenciar Botões/Lista"], ["/financeiro", "Financeiro"],
    ["/wallet-management", "Gerenciamento de Carteira"], ["/settings", "Configurações"],
    ["/announcements", "Avisos"], ["/companies", "Empresas"], ["/connections", "Conexões"],
    ["/allConnections", "Todas as Conexões"],
  ]],
];

export const HEADER_SUBMENU_DEFAULTS = HEADER_SUBMENU_GROUPS.flatMap(([parent, submenus]) =>
  submenus.map(([path, label]) => ({
    path,
    label,
    icon: SUBMENU_ICON_MAP[path] || "Settings",
    visible: true,
    parent,
  }))
);

export const getDefaultSubmenuParent = (path) => {
  const defaultSubmenu = HEADER_SUBMENU_DEFAULTS.find((item) => item.path === path);
  return defaultSubmenu?.parent || "attendance";
};

export const buildDefaultHeaderConfig = () => ({
  logoLink: "/tickets",
  systemFont: SYSTEM_FONT_DEFAULT,
  systemTitleFont: "",
  menusFont: "",
  messagesFont: "",
  announcementsFont: "",
  alertSound: "default",
  menusOrderCustomized: false,
  menus: HEADER_MENU_DEFAULTS.map((menu) => ({ ...menu })),
  rightActions: HEADER_RIGHT_ACTION_DEFAULTS.map((action) => ({ ...action })),
  submenus: HEADER_SUBMENU_DEFAULTS.map((submenu) => ({ ...submenu })),
});

export const normalizeHeaderLogoLink = (value) => {
  const path = String(value || "").trim().replace(/^#?\/?/, "");
  if (!path) return "/tickets";
  if (/^[a-z][a-z\d+.-]*:/i.test(path) || path.includes("//")) return "/tickets";
  return `/${path}`;
};

const HEADER_MENU_PARENT_KEYS = new Set(HEADER_MENU_DEFAULTS.map((menu) => menu.key));

const normalizeHeaderSubmenuPath = (value) => {
  const path = String(value || "").trim();
  if (!path) return "";
  if (path === "/") return "/";
  return `/${path.replace(/^#?\/?/, "")}`;
};

const normalizeHeaderSubmenu = (submenu, fallback = {}) => {
  const path = normalizeHeaderSubmenuPath(submenu?.path || fallback.path);
  if (!path) return null;
  const parent = String(submenu?.parent || fallback.parent || "attendance");
  const defaultIcon = SUBMENU_ICON_MAP[path] || fallback.icon || "Settings";
  const configuredIcon = submenu?.icon;

  // Modernize legacy default "Settings" icons to specific matching icons
  const icon = !configuredIcon || configuredIcon === "Settings" ? defaultIcon : configuredIcon;

  return {
    ...fallback,
    path,
    label: String(submenu?.label || fallback.label || path).trim() || fallback.label || path,
    icon,
    visible: submenu?.visible !== false,
    parent: HEADER_MENU_PARENT_KEYS.has(parent) ? parent : "attendance",
  };
};

export const parseHeaderConfig = (value) => {
  const defaults = buildDefaultHeaderConfig();
  if (!value) return defaults;

  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    const menusByKey = new Map(
      Array.isArray(parsed?.menus)
        ? parsed.menus.filter((menu) => menu && typeof menu.key === "string").map((menu) => [menu.key, menu])
        : []
    );
    const actionsByKey = new Map(
      Array.isArray(parsed?.rightActions)
        ? parsed.rightActions.filter((action) => action && typeof action.key === "string").map((action) => [action.key, action])
        : []
    );
    const submenusByPath = new Map(
      Array.isArray(parsed?.submenus)
        ? parsed.submenus.filter((submenu) => submenu && typeof submenu.path === "string").map((submenu) => [submenu.path, submenu])
        : []
    );
    const normalizedSubmenusByPath = new Map(
      Array.from(submenusByPath.values()).map((submenu) => [normalizeHeaderSubmenuPath(submenu.path), submenu])
    );
    const mergedSubmenus = defaults.submenus
      .map((submenu) => normalizeHeaderSubmenu(normalizedSubmenusByPath.get(submenu.path), submenu))
      .filter(Boolean);

    normalizedSubmenusByPath.forEach((submenu, normalizedPath) => {
      if (!normalizedPath || mergedSubmenus.some((item) => item.path === normalizedPath)) return;
      const normalized = normalizeHeaderSubmenu(submenu);
      if (normalized) mergedSubmenus.push(normalized);
    });

    const menusOrderCustomized = parsed?.menusOrderCustomized === true;

    return {
      logoLink: normalizeHeaderLogoLink(parsed?.logoLink),
      systemFont: getSystemFontOption(parsed?.systemFont).value,
      systemTitleFont: getSystemFontOverride(parsed?.systemTitleFont),
      menusFont: getSystemFontOverride(parsed?.menusFont),
      messagesFont: getSystemFontOverride(parsed?.messagesFont),
      announcementsFont: getSystemFontOverride(parsed?.announcementsFont),
      alertSound: typeof parsed?.alertSound === "string" && parsed.alertSound ? parsed.alertSound : "default",
      menusOrderCustomized,
      menus: defaults.menus
        .map((menu) => {
          const configured = menusByKey.get(menu.key) || {};
          const order = Number(configured.order);
          return {
            ...menu,
            label: String(configured.label || menu.label).trim() || menu.label,
            icon: String(configured.icon || menu.icon),
            visible: configured.visible !== false,
            order: menusOrderCustomized && Number.isFinite(order) && order > 0 ? order : menu.order,
          };
        })
        .sort((first, second) => first.order - second.order),
      rightActions: defaults.rightActions.map((action) => ({
        ...action,
        icon: String(actionsByKey.get(action.key)?.icon || action.icon),
        visible: actionsByKey.get(action.key)?.visible !== false,
      })),
      submenus: mergedSubmenus,
    };
  } catch (_error) {
    return defaults;
  }
};
